export default "__VITE_ASSET__8942cf54__"